import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CardFooterComponent } from '../../../shared/card-footer/card-footer.component';
import { HeaderComponent } from '../../../shared/header/header.component';
import { EmployerAuthService } from '../../../shared/services/employer-auth.service';
import { ErrorMessageService } from '../../../shared/services/error-message.service';

@Component({
  selector: 'app-password',
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    HeaderComponent,
    CardFooterComponent,
    TranslateModule,
  ],
  templateUrl: './password.component.html',
  styleUrl: './password.component.css',
})
export class PasswordComponent implements OnInit {
  email = '';
  loading = false;
  errorMessage = '';

  constructor(
    private titleService: Title,
    private router: Router,
    private translate: TranslateService,
    private employerAuthService: EmployerAuthService,
    private errorMessageService: ErrorMessageService
  ) { }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(() => {
      this.updateTitle();
    });
    this.updateTitle();
    this.translate.use(this.translate.currentLang || 'en');
  }

  updateTitle(): void {
    this.translate.get('EMPLOYER.PASSWORD.TITLE').subscribe((res: string) => {
      this.titleService.setTitle(res);
    });
  }

  isFormValid(): boolean {
    // Basic email validation using regex
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(this.email);
  }

  resetPassword() {
    if (!this.isFormValid()) {
      return;
    }

    this.loading = true;
    this.errorMessage = '';

    this.employerAuthService.initiateForgotPassword(this.email).subscribe({
      next: (response) => {
        this.loading = false;
        if (this.errorMessageService.isSuccessResponse(response) && response.data) {
          const sessionData = {
            sessionId: response.data.sessionId,
            email: this.email,
          };
          sessionStorage.setItem('employerSessionData', JSON.stringify(sessionData));
          this.router.navigate(['/employer/account/verify'], {
            queryParams: { type: 'password-reset' }
          });
        } else {
          this.errorMessageService.getErrorMessage(response.errorCode).subscribe(message => {
            this.errorMessage = message;
          });
        }
      },
      error: (error) => {
        this.loading = false;
        if (error.error && error.error.errorCode) {
          this.errorMessageService.getErrorMessage(error.error.errorCode).subscribe(message => {
            this.errorMessage = message;
          });
        } else {
          this.translate.get('error.internalServerError').subscribe(message => {
            this.errorMessage = message;
          });
        }
      }
    });
  }
}
